import '../../../../pricing-simulator/components/table-columns/table-columns.scss';
import React, { useEffect, useRef, useState } from 'react';
import { Checkbox } from '@mui/material';
import { Row } from '@tanstack/react-table';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { setDuplicateSkuCount } from '../../../store/innovation-slice';
import { Header } from '../../../../pricing-simulator/types/generic-table.model';

export default function BulkDuplicateSkuCheckbox({
  row,
  columnMetadata,
  section
}: {
  row: Row<{ [key: string]: any }>;
  columnMetadata: Header;
  section: string;
}) {
  // app dispatch for dispatching actions
  const appDispatch = useAppDispatch();
  // Getting state from innovation
  const { isBulkDuplicateResetClicked } = useAppSelector(
    (state) => state.innovation
  );

  // local state for number of duplicate input box
  const [duplicateCount, setDuplicateCount] = useState(1);

  // local state for checbox selected
  const [isCheckboxSelected, setCheckboxSelected] = useState(false);

  useEffect(() => {
    if (!isBulkDuplicateResetClicked) {
      // setCheckboxSelected(true);
    } else {
      row.toggleSelected(false);
      // setCheckboxSelected(false);
    }
  }, [isBulkDuplicateResetClicked]);

  const handleValueChange = (
    _e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    // row.toggleSelected(isCheckboxSelected);
    row.toggleSelected(checked);

    appDispatch(
      setDuplicateSkuCount({
        checked,
        skuName: row.original.sku,
        no_of_duplicates: duplicateCount,
        section
      })
    );
  };

  return (
    <div
      style={{
        position: 'relative'
      }}
    >
      <Checkbox
        checked={row.getIsSelected()}
        onChange={handleValueChange}
        size='small'
        placeholder='-'
      />
      {row.original[columnMetadata.parent.parent_field]}
      {row.original.is_finalized && (
        <div className='finalized-table-flag'>
          <img src='/static/icons/finalized-scenario.svg' alt='finalized' />
        </div>
      )}
    </div>
  );
}
